
import { URLS } from '../constants'
import {
    GET_ALL_BYPASS_CUSTOMERS_BEGIN, GET_ALL_BYPASS_CUSTOMERS_SUCCESS, GET_ALL_BYPASS_CUSTOMERS_FAILURE,
    SET_BYPASS_CUSTOMERS_QUERY,
    GET_BYPASS_CUSTOMER_BEGIN, GET_BYPASS_CUSTOMER_SUCCESS, GET_BYPASS_CUSTOMER_FAILURE,
    POST_BYPASS_CUSTOMER_BEGIN, POST_BYPASS_CUSTOMER_SUCCESS, POST_BYPASS_CUSTOMER_FAILURE,
    DELETE_BYPASS_CUSTOMER_BEGIN, DELETE_BYPASS_CUSTOMER_SUCCESS, DELETE_BYPASS_CUSTOMER_FAILURE,
    CLEAN_BYPASS_CUSTOMER
} from '../constants/ActionTypes'

import { dispatchFetchGet, dispatchFetchPost, dispatchFetchDelete, setUrlSearchParams } from './ActionUtil'

// Get All Bypass Customers
const acGetAllBypassCustomersBegin = () => ({ type: GET_ALL_BYPASS_CUSTOMERS_BEGIN })
const acGetAllBypassCustomersSuccess = data => ({ type: GET_ALL_BYPASS_CUSTOMERS_SUCCESS, payload: data })
const acGetAllBypassCustomersFailure = err => ({ type: GET_ALL_BYPASS_CUSTOMERS_FAILURE, payload: err })

/**
 * @description Retrieves all bypass customers.
 * 
 * @author Maria Eduarda Franke
 */
export const acGetAllBypassCustomers = payload => {

    let url = URLS.BYPASS_CUSTOMER

    if (payload) {
        url = setUrlSearchParams(url, payload)
    }

    return dispatch => (
        dispatch(dispatchFetchGet(
            url,
            acGetAllBypassCustomersBegin,
            acGetAllBypassCustomersSuccess,
            acGetAllBypassCustomersFailure
        ))
            .then(() => {
                if (payload) {
                    dispatch({ type: SET_BYPASS_CUSTOMERS_QUERY, payload })
                }
            })
            .catch((err) => {
                console.log("ERROR ON acGetAllBypassCustomers")
                console.log(err)
            })
    )
}

// Get Bypass Customer
const acGetBypassCustomerBegin = () => ({ type: GET_BYPASS_CUSTOMER_BEGIN })
const acGetBypassCustomerSuccess = data => ({ type: GET_BYPASS_CUSTOMER_SUCCESS, payload: data })
const acGetBypassCustomerFailure = err => ({ type: GET_BYPASS_CUSTOMER_FAILURE, payload: err })

/**
 * @description Dispatches a GET request to retrieve a bypass customer.
 *
 * @author Maria Eduarda Franke
 */
export const acGetBypassCustomer = bypassCustomerId => {
    return dispatchFetchGet(
        `${URLS.BYPASS_CUSTOMER}/${bypassCustomerId}`,
        acGetBypassCustomerBegin,
        acGetBypassCustomerSuccess,
        acGetBypassCustomerFailure
    )
}

// Post Bypass Customer
const acPostBypassCustomerBegin = () => ({ type: POST_BYPASS_CUSTOMER_BEGIN })
const acPostBypassCustomerSuccess = data => ({ type: POST_BYPASS_CUSTOMER_SUCCESS, payload: data })
const acPostBypassCustomerFailure = err => ({ type: POST_BYPASS_CUSTOMER_FAILURE, payload: err })

/**
 * @description Dispatches a POST request to create a bypass customer.
 *
 * @author Maria Eduarda Franke
 */
export const acPostBypassCustomer = bypassCustomer => {
    return dispatchFetchPost(
        URLS.BYPASS_CUSTOMER,
        { ...bypassCustomer },
        acPostBypassCustomerBegin,
        acPostBypassCustomerSuccess,
        acPostBypassCustomerFailure
    )
}

// Delete Bypass Customer
const acDeleteBypassCustomerBegin = () => ({ type: DELETE_BYPASS_CUSTOMER_BEGIN })
const acDeleteBypassCustomerSuccess = data => ({ type: DELETE_BYPASS_CUSTOMER_SUCCESS, payload: data })
const acDeleteBypassCustomerFailure = err => ({ type: DELETE_BYPASS_CUSTOMER_FAILURE, payload: err })

/**
 * @description Dispatches a DELETE request to delete a bypass customer.
 *
 * @author Maria Eduarda Franke
 */
export const acDeleteBypassCustomer = bypassCustomerId => {
    return dispatchFetchDelete(
        `${URLS.BYPASS_CUSTOMER}/${bypassCustomerId}`,
        acDeleteBypassCustomerBegin,
        acDeleteBypassCustomerSuccess,
        acDeleteBypassCustomerFailure
    )
}

// Clean Bypass Customer
export const acCleanBypassCustomer = () => ({ type: CLEAN_BYPASS_CUSTOMER })